module.exports = __webpack_public_path__ + "img/speedometer-02.86bb7949.svg";